<template>

  <slot name="button">
    <button type="button" :aria-label="ariaLabel" class="btn btn-primary" @click="ShowModal" :id="ModalId+'_btn'">
      {{ ButtonText }}
    </button>
  </slot>
  <div class="modal fade" :id="ModalId" tabindex="-1" aria-hidden="true" ref="modalRef">
    <div class="modal-dialog" :class="modalSizeComputed">
      <div class="modal-content">
        <div class="modal-header">
          <h5 tabindex="0" aria-label="{{ModalTitle}}" class="modal-title" id="">{{ ModalTitle }}</h5>
          <button  aria-label="CLose this modal window" type="button" id="btnCloseModal" class="btn-close btn-close-white" data-bs-dismiss="modal" title="Close this modal window"></button>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button tabindex="0" type="button" class="btn btn-secondary" aria-label="CLose this modal window" data-bs-dismiss="modal">Close</button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const bootstrap = require("bootstrap");
import $ from "jquery";

//import { Modal } from 'bootstrap';

export default {
  name: "ModalBootstrap",
  props: {
    ModalId: String,
    ModalTitle: String,
    ButtonText: String,
    ariaLabel: String,
    ModalSizeClass:String,
  },
  data(){
    return{
      myModal: null,
      modalSize:"",
    }
  },
  computed:{
    modalSizeComputed(){
      if(this.modalSize == null)
        return "modal-lg";
      return this.modalSize; 
    }
  },
  async mounted() {
    this.modalSize = this.ModalSizeClass; 
    if(this.ButtonText == ""){
      $("#"+this.ModalId + "_btn").hide(); 
    }

    $('#' + this.ModalId).on("hidden.bs.modal", () =>{
      //console.log("Modal hidden");
      this.$emit("modalCloseEvent");
    });
  },
  emits:["modalOpenEvent","modalCloseEvent"],
  methods: {
    ShowModal() {
      this.myModal = new bootstrap.Modal(document.getElementById(this.ModalId));

      this.myModal.show();
      this.$emit("modalOpenEvent");
    },
    HideModal(e) {
      if(e != null)
        e.preventDefault();
      //console.log("close modal");
      this.myModal.hide();
      this.$emit("modalCloseEvent");
    },
  },
  unmounted(){
    if(this.myModal != null)
      this.HideModal();
  }
};
</script>

<style scoped>

.modal-header{
  background-color: #1063A8 ;
  color:white;
}
#btnCloseModal{
  padding-top:18px !important;
}
@import "~bootstrap/dist/css/bootstrap.css";
</style>
